import axios from '../config/axiosPrivate';

export const getUnits = async (communityId: number) => {
  const response = await axios.get(`/units/${communityId}`);
  return response.data;
};
